<template>
<div>

<v-dialog persistent v-model="modals.deleteServer" width="350">
<v-card>
<v-toolbar dark  color="#273C51" flat  height="42">
<v-toolbar-title  >  Удаление  сервера  </v-toolbar-title>
<v-spacer></v-spacer>
<v-icon @click="modals.deleteServer = false">mdi-close</v-icon>
</v-toolbar>
<v-card-text scrollable>
<div style=" min-height:60px;color:gray">
<div> Подтвердите удаление сервера - <span style="color:green">{{selectedToDelete.item.title}}</span>, вы всегда сможете добавить сервер обратно. </div>
</div>
</v-card-text>
<v-divider/>
<v-card-actions>
<v-spacer/>
<v-btn style="text-transform:none" color="#273C51" small flat @click="modals.deleteServer = false">Отмена</v-btn>
<v-btn style="text-transform:none" color="red" small class="white--text" @click="deleteServer(selectedToDelete.item,selectedToDelete.i)" ><v-icon>mdi-delete</v-icon> Удалить </v-btn>
</v-card-actions>
</v-card>
</v-dialog>











<v-layout row wrap>

<v-flex d-flex v-for="item,i in servers.serverList" :key="item.ip">

<v-card    class="serverListCard">
<v-toolbar flat  card dense dark>
  <v-icon style="margin-left:-10px"  color="green">mdi-information</v-icon>
  <v-toolbar-title style="width:75%;">{{item.title}}</v-toolbar-title>
  <v-spacer></v-spacer>
  <div style="margin-right:-15px">
  <v-icon @click="deleteServerConfirm(item,i)" color="red">mdi-close</v-icon>
  </div>
</v-toolbar>
<v-card-text>
  <div>IP: <span @click='showIp(item)' style="color:gray">кликните что бы посмотреть</span></div>
  <div>Status:
  <span v-if="item.status == 1" style="color:gray">Не определенно</span>
  <span v-if="item.status == 2" style="color:green">Активен</span>
  <span v-if="item.status == 3" style="color:red">Ошибка соединения</span>
  </div>
</v-card-text>
<v-divider></v-divider>
<v-card-actions>
<v-spacer></v-spacer>

<v-btn @click="deleteServerConfirm(item,i)"  flat small color="red"  style="text-transform:none !important">
  <v-icon small style="margin-right:5px">mdi-delete</v-icon>
  Удалить
</v-btn>

<v-btn @click="selectServer(item)" flat small color="green"  style="text-transform:none !important">
  <v-icon style="margin-right:5px">mdi-arrow-right-bold-circle</v-icon>
  Выбрать
</v-btn>

</v-card-actions>
</v-card>

</v-flex>

<v-flex d-flex>
  <v-card    class="serverListCard">
    <v-toolbar color="gray" flat   card dense >
      <v-toolbar-title style="width:75%;margin-left:-10px">Новый сервер</v-toolbar-title>
      <v-spacer></v-spacer>
      <div style="margin-right:-15px">
      <v-icon @click="openCreator()">mdi-plus</v-icon>
      </div>
    </v-toolbar>
    <v-card-text style="color:gray">
      <h4>Нет сервера ?</h4>
      <div>Обратитесь в <a target="_blank " style="text-decoration:none" href="https://t.me/vkparser">поддержку</a>.</div>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions>
    <v-spacer></v-spacer>

    <v-btn @click="openCreator()" flat small color="#273C51"  style="text-transform:none !important">
      <v-icon style="margin-right:5px">mdi-plus</v-icon>
      Добавить сервер
    </v-btn>

    </v-card-actions>
  </v-card>
</v-flex>


<v-flex d-flex>
  <v-card flat style="background-color:#273C51"   class="serverListCard">
  </v-card>
</v-flex>

<v-flex d-flex >
  <v-card flat  style="background-color:#273C51"   class="serverListCard">
  </v-card>
</v-flex>

</v-layout>



<v-dialog scrollable persistent v-model="modals.creator" width="550px">
<CreateServer  :modals='modals' :servers="servers" />
</v-dialog>


</div>
</template>

<script>
import CreateServer from './create_server.vue'
export default {
  name: 'App',
  components:{CreateServer},
  data: () => ({
    selectedToDelete:{
      item:{},
      id:0,
    },
    modals:{
      creator:false,
      deleteServer: false,
    },
    servers:{
      serverList:[],
    },


    //
  }),
  methods:{
    deleteServerConfirm(item,i){
      this.selectedToDelete.item = item
      this.selectedToDelete.i = i
      this.modals.deleteServer = true
    },
    showIp(item){alert(item.server)},
    openCreator(){
      this.modals.creator = true
    },
    deleteServer(item,i){
      let server = JSON.parse(localStorage.server)
      let servers = JSON.parse(localStorage.servers)
      servers.splice(i,1)
      localStorage.servers = JSON.stringify(servers)
      if(servers.length == 0){
        localStorage.clear()
      }
      if(server.server === item.server){localStorage.removeItem('server')}
      this.$router.go()
    },
    selectServer(item){
      localStorage.server = JSON.stringify(item)
      this.$router.push('/parser')
      this.$router.go()

    },



  },

  created(){
    if(localStorage.servers){
      this.servers.serverList = JSON.parse(localStorage.servers)
    }
  },
};
</script>

<style>
.serverListCard {
  margin-left:0px;
  margin-right:20px;
  margin-bottom:20px;
  width:270px;
}
</style>
